export const TrustTaxInfoContent = {
  pageTitle: 'Enter the trust’s tax information',
  fullTrustName: 'Full legal trust name:',
  taxClassification: 'Federal tax classification:',
  withholdingQuestion: 'Are you subject to backup withholding?',
  withholdingOptions: [
    'Yes, I am subject to backup withholding',
    'No, I am not subject to backup withholding',
  ],
  withholdingTooltip: 'The IRS will notify you directly if you are subject to backup withholding.',
  certifyText: 'By clicking “Continue” you certify that:',
  certifyOptionsNotSubject: [
    'The number shown on this form is the correct taxpayer identification number (or I am waiting for a number to be issued to me); and',
    'I am not subject to backup withholding because (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and',
    'I am a U.S. citizen or other U.S. person (as defined in the <a class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary" href="https://www.irs.gov/forms-pubs/about-form-w-9" target="_blank"><span class="c11n-link__content">IRS W-9 instructions</span></a>); and',
    'The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.',
  ],
  certifyOptionsSubject: [
    'The number shown on this form is the correct taxpayer identification number (or I am waiting for a number to be issued to me); and',
    'I am a U.S. citizen or other U.S. person (as defined in the <a class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary" href="https://www.irs.gov/forms-pubs/about-form-w-9" target="_blank"><span class="c11n-link__content">IRS W-9 instructions</span></a>); and ',
    'The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct. ',
  ],
  signatureLabel: 'Signature',
  signatureSubLabel: 'Enter your name as it appears on your account',
  dateLabel: 'Date',
  questionErrorText: 'Please select an option.',
  signatureErrorText: 'Please enter your signature.',
  EINLabel: 'EIN',
  requiredError: 'This field is required',
  continueButton: 'Continue',
  grantorName: 'Living grantor’s name',
  grantorSSN: 'Living grantor’s Social Security number',
  grantorNameTooltip: `
    If all grantors are deceased, you’ll need to use an EIN. You can apply for one at
    <a class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary c11n-link--on-dark" href="https://www.irs.gov/" target="_blank"><span class="c11n-link__content">IRS.gov</span></a>.
  `,
  grantorSSNMatchesDecedentError: "Grantor’s SSN cannot be the decedent's Social Security number.",
  EINMatchesDecedentError: "EIN cannot be the decedent's Social Security number.",
  numberQuestion: 'Will the new trust account report under an EIN or another grantor’s SSN?',
  numberQuestionOptions: ['EIN', 'Social Security number'],
  grantorQuestion: 'Is the grantor a U.S. citizen?',
  countryOptions: ['U.S.', 'Other'],
};
